import React from "react";
import { useQuery } from "@apollo/client";

import { GET_GROUP_ANALYTES } from "../../../queries/archiveQrys/secureQrys/ipsViolationQrys";
import LoadingSpinner from "../../reuseableComponents/loaders/LoadingSpinner";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";

const AnalyteGroupForm = ({ item }) => {

    if (item) {
        console.log("Item: ", item);
    }

    const { data, loading, error } = useQuery(GET_GROUP_ANALYTES, { skip: !item, variables: { groupId: item?.anlytGrpId }});

    if (loading || error) {
        return (
            <>
                {loading && <LoadingSpinner />}
                {error && (<p>Error: {error.message}</p>)}
            </>
        );
    }

    if (data) {
        console.log("Data: ", data);
    }

    const analytes = data?.getAnalytesByGroupId;
    let columns = [
        {
            Header: "Analyte Name",
            accessor: (d) => {
                return d.analyteName
            }
        },
        {
            Header: "Analyte Code",
            accessor: (d) => {
                return d.analyteCode
            }
        },
    ];

    return (
    <div>
        {data && <DtsReactTable data={analytes} columns={columns} headerColor="grey"/>}
    </div>
    );
};

export default AnalyteGroupForm;